import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import LeftSideNavigation from "../navigationSection/LeftSideNavigation";
import RightSideNavigation from "../navigationSection/RightSideNavigation";
import { TopNavigationBarMobile } from "../navigationSection/TopNavigationBarMobile";
import RightComponentOrderRequest, {
  PaymentSuccessModel,
} from "./OrderRequest/RightComponentOrderRequest";
import OrderPaymentMain from "./OrderPaymentMain";
import { AmealioLoader } from "../../Loader/AmealioLoader";
import { connect } from "react-redux";
import Media from "react-media";
import { Hidden } from "@material-ui/core";
import { BottomNavigationMobile } from "../navigationSection/BottomNavigationMobile";
//import {PaymentSuccessModel} from '../'
const OrderPayment = (props) => {
  const [show, setShow] = useState(false);
  const [data, setData] = useState({});
  const onSetData = (orderData) => {
    setData(orderData);
  };
  try {
    return (
      <React.Fragment>
        <PaymentSuccessModel open={show} data={data} />
        {props.auth.loader ? (
          <AmealioLoader />
        ) : (
          <React.Fragment>
            <Container fluid className="vendor-orders-request">
              <Row>
                <Media query="(min-width: 992px)">
                  <div className="left-side-panel">
                    <LeftSideNavigation />
                  </div>
                </Media>
                <div className="top-panel">
                  <TopNavigationBarMobile displayLeft="logo" />
                </div>
                <div className="right-side-panel">
                  <RightSideNavigation />
                  <Container fluid className="mobile-p-0">
                    <Row>
                      <Col md={8} xs={12}>
                        <OrderPaymentMain />
                      </Col>
                      <Hidden mdDown>
                        <Col md={4}>
                          <RightComponentOrderRequest
                            payment={true}
                            setShow={() => setShow(true)}
                            setData={(orderData) => onSetData(orderData)}
                          />
                        </Col>
                      </Hidden>
                    </Row>
                  </Container>
                </div>
                <Media query="(max-width: 991px)">
                  <div className="bottom-panel">
                    <BottomNavigationMobile />
                  </div>
                </Media>
              </Row>
            </Container>
          </React.Fragment>
        )}
      </React.Fragment>
    );
  } catch (e) {
    console.log(e);
  }
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, null)(OrderPayment);
